// Données des activités pour le SEO et contenu

export const activitiesData = {
  'orange-bay': {
    id: 'orange-bay',
    slug: 'orange-bay',
    title: 'Orange Bay Hurghada',
    metaTitle: 'Orange Bay Hurghada – Île Paradisiaque Mer Rouge | Réservez en Français',
    metaDescription: 'Découvrez Orange Bay, île paradisiaque en Mer Rouge. Snorkeling, eaux cristallines, déjeuner inclus. Réservation simple en français via WhatsApp.',
    h1: 'Orange Bay – Île paradisiaque en Mer Rouge',
    price: 25,
    priceNote: 'Transport + déjeuner inclus',
    duration: '1 jour',
    departurePoint: 'Hôtel',
    departure: 'Entre 7h30 et 8h30',
    return: 'Vers 17h00',
    stripeLink: 'https://buy.stripe.com/9B6cN44Ml5mwfgP77vdMI03',
    depositAmount: 5,
    shortDescription: 'Découvrez l\'île d\'Orange Bay, nagez dans des eaux cristallines et profitez d\'une session de snorkeling exceptionnelle en mer Rouge.',
    images: [
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767543315/orange-bay-hurghada-island_1_zvq1zw.jpg',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767543314/orange-bay-hurghada-island_4_kgfkqc.jpg',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767543316/orange-bay-hurghada-island_5_lf4q4c.jpg'
    ],
    experience: [
      'Prise en charge à votre hôtel entre 7h30 et 8h30',
      'Départ en bateau vers 9h00',
      'Arrêt sur l\'un des meilleurs spots de snorkeling (matériel fourni)',
      'Buffet à volonté servi sur le bateau',
      'Transfert en bateau moteur vers l\'île d\'Orange Bay',
      '1h30 de temps libre sur l\'île (glaces, cocktails, chicha disponibles en option)',
      'Retour en bateau avec jeux aquatiques inclus (banane, sofa)',
      'Retour à l\'hôtel prévu vers 17h00'
    ],
    included: [
      'Transfert hôtel aller-retour (si hôtel situé à Hurghada)',
      'Déjeuner et boissons',
      'Matériel de snorkeling',
      'Jeux aquatiques (banane, sofa)'
    ],
    notIncluded: [
      'Glaces, cocktails, chicha (en option sur l\'île)',
      'Pourboires (optionnel)'
    ],
    practicalInfo: {
      duration: '1 jour',
      departurePoint: 'Hôtel',
      departureTime: 'Entre 7h30 et 8h30',
      returnTime: 'Vers 17h00'
    },
    faq: [
      {
        question: 'Le transfert depuis mon hôtel est-il inclus ?',
        answer: 'Oui, la prise en charge depuis ton hôtel à Hurghada est incluse, sauf mention contraire.'
      },
      {
        question: 'Comment se passe le paiement ?',
        answer: 'Tu réserves ton pack avec un acompte sécurisé via Stripe. Le solde est à régler le jour de l\'excursion, directement auprès du prestataire local. Aucun frais caché, tout est clair dès le départ.'
      },
      {
        question: 'Comment se passe la confirmation ?',
        answer: 'Après le paiement, je te contacte directement sur WhatsApp pour confirmer tous les détails.'
      },
      {
        question: 'Puis-je poser des questions sur cette activité ?',
        answer: 'Oui, je suis disponible à tout moment sur WhatsApp avant et après la réservation.'
      },
      {
        question: 'Faut-il avoir déjà plongé ?',
        answer: 'Non. Les débutants sont acceptés et accompagnés par des professionnels.'
      },
      {
        question: 'Le matériel est-il inclus ?',
        answer: 'Oui, tout le matériel nécessaire est fourni.'
      },
      {
        question: 'Est-ce adapté aux débutants ?',
        answer: 'Oui, les activités sont encadrées et adaptées aux personnes sans expérience.'
      }
    ]
  },
  'dauphins-hurghada': {
    id: 'dauphins-hurghada',
    slug: 'dauphins-hurghada',
    title: 'Nager avec les dauphins à Hurghada',
    metaTitle: 'Nager avec les Dauphins Hurghada – Excursion Mer Rouge | Réservez en Français',
    metaDescription: 'Nagez avec les dauphins sauvages en Mer Rouge. Excursion encadrée, snorkeling inclus. Réservation simple en français via WhatsApp.',
    h1: 'Nager avec les dauphins à Hurghada',
    price: 25,
    priceNote: 'Transport inclus • Repas et boissons inclus',
    duration: '1 jour',
    departurePoint: 'Hôtel',
    departure: 'Vers 8h00',
    return: 'Vers 15h30',
    stripeLink: 'https://buy.stripe.com/5kQdR83IhcOYc4DbnLdMI04',
    depositAmount: 7,
    shortDescription: 'Excursion organisée dans les meilleures conditions possibles pour maximiser les chances d\'approcher les dauphins dans leur environnement naturel.',
    images: [
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767546316/dolphin-house-snorkeling_2_xgicwk.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767546317/dolphin-house-snorkeling_1_ydusys.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767546314/dolphin-house-snorkeling_4_vngirm.png'
    ],
    experience: [
      'Prise en charge à votre hôtel vers 8h00',
      'Transfert vers la marina',
      'Départ du bateau vers 9h00',
      'Briefing sécurité avant la mise à l\'eau',
      'Nage avec les dauphins encadrée par 2 moniteurs expérimentés',
      'Plusieurs arrêts selon la localisation des dauphins',
      'Séance de snorkeling possible',
      'Buffet à volonté servi à bord',
      'Retour à la marina vers 15h00',
      'Transfert retour vers votre hôtel'
    ],
    included: [
      'Transfert hôtel aller-retour (Hurghada uniquement)',
      'Repas et boissons',
      'Matériel de snorkeling'
    ],
    notIncluded: [
      'Photos/vidéos souvenirs',
      'Pourboires (optionnel)'
    ],
    practicalInfo: {
      duration: '1 jour',
      departurePoint: 'Hôtel',
      departureTime: 'Vers 8h00',
      returnTime: 'Vers 15h30'
    },
    faq: [
      {
        question: 'Le transfert depuis mon hôtel est-il inclus ?',
        answer: 'Oui, la prise en charge depuis ton hôtel à Hurghada est incluse, sauf mention contraire.'
      },
      {
        question: 'Comment se passe le paiement ?',
        answer: 'Tu réserves ton pack avec un acompte sécurisé via Stripe. Le solde est à régler le jour de l\'excursion, directement auprès du prestataire local. Aucun frais caché, tout est clair dès le départ.'
      },
      {
        question: 'Comment se passe la confirmation ?',
        answer: 'Après le paiement, je te contacte directement sur WhatsApp pour confirmer tous les détails.'
      },
      {
        question: 'Puis-je poser des questions sur cette activité ?',
        answer: 'Oui, je suis disponible à tout moment sur WhatsApp avant et après la réservation.'
      },
      {
        question: 'Les dauphins sont-ils en liberté ?',
        answer: 'Oui. Les dauphins sont observés en milieu naturel, dans le respect de leur environnement.'
      },
      {
        question: 'Est-ce garanti de voir des dauphins ?',
        answer: 'Les observations sont très fréquentes, mais comme il s\'agit d\'animaux sauvages, elles ne peuvent jamais être garanties à 100 %.'
      },
      {
        question: 'L\'activité est-elle respectueuse des animaux ?',
        answer: 'Oui. Les sorties respectent les règles locales de protection des dauphins.'
      }
    ]
  },
  'plongee-sous-marine': {
    id: 'plongee-sous-marine',
    slug: 'plongee-sous-marine',
    title: 'Plongée sous-marine à Hurghada',
    metaTitle: 'Plongée Sous-Marine Hurghada – Baptême & Certifiés | Réservez en Français',
    metaDescription: 'Plongée sous-marine à Hurghada pour débutants et certifiés. Sites exceptionnels en Mer Rouge. Réservation simple en français via WhatsApp.',
    h1: 'Plongée sous-marine à Hurghada',
    price: 30,
    priceLabel: 'Débutant : 30€ • Certifié : 40€',
    priceNote: 'Transport inclus • Repas et boissons inclus',
    duration: '1 jour',
    departurePoint: 'Hôtel',
    departure: 'Vers 8h00',
    return: 'Vers 16h30',
    stripeLink: 'https://buy.stripe.com/cNibJ03Ih4isd8HfE1dMI0a',
    depositAmount: 14,
    shortDescription: 'Découvrez les plus beaux sites de plongée de la mer Rouge lors d\'une excursion encadrée par des moniteurs professionnels.',
    images: [
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767552523/scuba-diving-hurghada-underwater.jpg_4_ws4xrr.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767552559/scuba-diving-hurghada-underwater.jpg_2_qofds3.jpg',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767553362/scuba-diving-hurghada-underwater.jpg_3_eu72hs.png'
    ],
    experience: [
      'Prise en charge hôtel vers 8h00',
      'Départ bateau vers 9h00',
      'Formation pendant la navigation pour débutants',
      'Deux sites de plongée sélectionnés',
      'Plongée encadrée (max 10 m, ~10 min)',
      'Snorkeling possible selon conditions',
      'Buffet à volonté à bord',
      'Retour marina + transfert hôtel'
    ],
    included: [
      'Transfert hôtel aller-retour',
      'Matériel de plongée',
      'Matériel de snorkeling',
      'Repas et boissons'
    ],
    notIncluded: [
      'Photos/vidéos sous-marines',
      'Pourboires (optionnel)'
    ],
    practicalInfo: {
      duration: '1 jour',
      departurePoint: 'Hôtel',
      departureTime: 'Vers 8h00',
      returnTime: 'Vers 16h30'
    },
    faq: [
      {
        question: 'Le transfert depuis mon hôtel est-il inclus ?',
        answer: 'Oui, la prise en charge depuis ton hôtel à Hurghada est incluse, sauf mention contraire.'
      },
      {
        question: 'Comment se passe le paiement ?',
        answer: 'Tu réserves ton pack avec un acompte sécurisé via Stripe. Le solde est à régler le jour de l\'excursion, directement auprès du prestataire local. Aucun frais caché, tout est clair dès le départ.'
      },
      {
        question: 'Comment se passe la confirmation ?',
        answer: 'Après le paiement, je te contacte directement sur WhatsApp pour confirmer tous les détails.'
      },
      {
        question: 'Puis-je poser des questions sur cette activité ?',
        answer: 'Oui, je suis disponible à tout moment sur WhatsApp avant et après la réservation.'
      },
      {
        question: 'Faut-il avoir déjà plongé ?',
        answer: 'Non. Les débutants sont acceptés et accompagnés par des professionnels.'
      },
      {
        question: 'Le matériel est-il inclus ?',
        answer: 'Oui, tout le matériel nécessaire est fourni.'
      },
      {
        question: 'Est-ce adapté aux débutants ?',
        answer: 'Oui, les activités sont encadrées et adaptées aux personnes sans expérience.'
      }
    ]
  },
  'safari-combine-quad-desert': {
    id: 'safari-combine-quad-desert',
    slug: 'safari-combine-quad-desert',
    title: 'Super Safari à Hurghada',
    metaTitle: 'Super Safari Hurghada – Quad, Buggy & Désert | Réservez en Français',
    metaDescription: 'Super Safari à Hurghada : quad, buggy, Jeep, village bédouin et dîner. Réservation simple en français via WhatsApp.',
    h1: 'Super Safari à Hurghada',
    price: 35,
    priceNote: 'Transport inclus • Dîner inclus',
    duration: 'Après-midi',
    departurePoint: 'Hôtel',
    departure: 'Après-midi',
    return: 'Vers 19h00',
    stripeLink: 'https://buy.stripe.com/bJe4gy4Ml16g3y7fE1dMI09',
    depositAmount: 5,
    images: [
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767545999/safari-quad-jeep-desert-hurghada.png_7_yph7tf.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767545997/safari-quad-jeep-desert-hurghada.png_vjrcen.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767545994/safari-quad-jeep-desert-hurghada.png_9_wnaikb.png'
    ],
    shortDescription: 'Explorez le désert d\'Hurghada lors d\'une excursion mêlant aventure, culture locale et dîner traditionnel.',
    experience: [
      'Prise en charge hôtel l\'après-midi',
      '30 minutes de quad',
      '20 minutes de buggy',
      'Trek de 25 km en Jeep',
      'Visite d\'un village bédouin',
      'Buffet à volonté + spectacle oriental',
      'Fin vers 19h00',
      'Retour hôtel'
    ],
    included: [
      'Buffet à volonté + 1 boisson',
      'Transfert hôtel aller-retour'
    ],
    notIncluded: [
      'Boissons supplémentaires',
      'Photos professionnelles',
      'Pourboires (optionnel)'
    ],
    practicalInfo: {
      duration: 'Après-midi',
      departurePoint: 'Hôtel',
      departureTime: 'Après-midi',
      returnTime: 'Vers 19h00'
    },
    faq: [
      {
        question: 'Le transfert depuis mon hôtel est-il inclus ?',
        answer: 'Oui, la prise en charge depuis ton hôtel à Hurghada est incluse, sauf mention contraire.'
      },
      {
        question: 'Comment se passe le paiement ?',
        answer: 'Tu réserves ton pack avec un acompte sécurisé via Stripe. Le solde est à régler le jour de l\'excursion, directement auprès du prestataire local. Aucun frais caché, tout est clair dès le départ.'
      },
      {
        question: 'Comment se passe la confirmation ?',
        answer: 'Après le paiement, je te contacte directement sur WhatsApp pour confirmer tous les détails.'
      },
      {
        question: 'Puis-je poser des questions sur cette activité ?',
        answer: 'Oui, je suis disponible à tout moment sur WhatsApp avant et après la réservation.'
      },
      {
        question: 'Le quad est-il dangereux ?',
        answer: 'Non. Les quads sont faciles à prendre en main et une explication est donnée avant le départ. L\'activité est encadrée par des professionnels.'
      },
      {
        question: 'Faut-il un permis pour conduire le quad ?',
        answer: 'Non, aucun permis n\'est nécessaire.'
      },
      {
        question: 'Les enfants peuvent-ils participer ?',
        answer: 'Oui, les enfants peuvent participer en tant que passager, selon l\'âge.'
      }
    ]
  },
  'le-caire-1-jour': {
    id: 'le-caire-1-jour',
    slug: 'le-caire-1-jour',
    title: 'Excursion au Caire depuis Hurghada – 1 jour',
    metaTitle: 'Excursion Le Caire 1 Jour depuis Hurghada – Pyramides | Réservez en Français',
    metaDescription: 'Visitez Le Caire et les Pyramides en 1 jour depuis Hurghada. Guide francophone, déjeuner inclus. Réservation française via WhatsApp.',
    h1: 'Excursion au Caire depuis Hurghada – 1 jour',
    price: 75,
    priceNote: 'Transport inclus • Repas inclus',
    duration: '1 jour',
    departurePoint: 'Hôtel',
    departure: '1h00 – 2h00',
    return: 'Vers 23h00',
    stripeLink: 'https://buy.stripe.com/cNicN4gv32ak3y7dvTdMI08',
    depositAmount: 15,
    shortDescription: 'Partez à la découverte de l\'histoire de l\'Égypte lors d\'une excursion fluide et bien organisée.',
    optional: 'Croisière sur le Nil : +10€ / personne',
    images: [
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767546253/cairo-day-tour-pyramids_2_xdug4t.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767546260/cairo-day-tour-pyramids_2_fo7o2q.jpg',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767546252/cairo-day-tour-pyramids_1_xgikpy.jpg'
    ],
    experience: [
      'Prise en charge hôtel entre 1h00 et 2h00',
      'Mini-van climatisé (8 pers max)',
      'Collation matinale',
      'Pyramides & Sphinx',
      'Guide francophone',
      'Musée du Caire',
      'Déjeuner buffet',
      'Fabrique papyrus & parfums',
      'Retour hôtel vers 23h00'
    ],
    included: [
      'Billets d\'entrées',
      'Collation',
      'Buffet + boisson',
      'Transfert hôtel aller-retour'
    ],
    notIncluded: [
      'Croisière sur le Nil (+10€)',
      'Pourboires (optionnel)'
    ],
    practicalInfo: {
      duration: '1 jour',
      departurePoint: 'Hôtel',
      departureTime: '1h00 – 2h00',
      returnTime: 'Vers 23h00'
    },
    faq: [
      {
        question: 'Le transfert depuis mon hôtel est-il inclus ?',
        answer: 'Oui, la prise en charge depuis ton hôtel à Hurghada est incluse, sauf mention contraire.'
      },
      {
        question: 'Comment se passe le paiement ?',
        answer: 'Tu réserves ton pack avec un acompte sécurisé via Stripe. Le solde est à régler le jour de l\'excursion, directement auprès du prestataire local. Aucun frais caché, tout est clair dès le départ.'
      },
      {
        question: 'Comment se passe la confirmation ?',
        answer: 'Après le paiement, je te contacte directement sur WhatsApp pour confirmer tous les détails.'
      },
      {
        question: 'Puis-je poser des questions sur cette activité ?',
        answer: 'Oui, je suis disponible à tout moment sur WhatsApp avant et après la réservation.'
      }
    ]
  },
  'luxor-1-jour': {
    id: 'luxor-1-jour',
    slug: 'luxor-1-jour',
    title: 'Excursion à Louxor – Vallée des Rois',
    metaTitle: 'Excursion Louxor 1 Jour depuis Hurghada – Vallée des Rois | Réservez en Français',
    metaDescription: 'Visitez Louxor, la Vallée des Rois et Karnak en 1 jour depuis Hurghada. Réservation française via WhatsApp.',
    h1: 'Excursion à Louxor – Vallée des Rois',
    price: 75,
    priceNote: 'Transport inclus • Repas inclus',
    duration: '1 jour',
    departurePoint: 'Hôtel',
    departure: '4h00 – 5h00',
    return: 'Vers 21h00',
    stripeLink: 'https://buy.stripe.com/aFa9ASceNeX6fgP0J7dMI07',
    depositAmount: 13,
    shortDescription: 'Découvrez Louxor et ses monuments emblématiques lors d\'une excursion culturelle.',
    availableDays: 'Dimanche, Mardi, Jeudi',
    optional: 'Découverte de Banana Island, sur le Nil : +10€ / personne',
    images: [
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767545542/luxor-day-tour-valley-of-the-kings_6_c7vqbr.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767545546/luxor-day-tour-valley-of-the-kings_1_ul1vtl.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767545544/luxor-day-tour-valley-of-the-kings_2_o6wses.png'
    ],
    experience: [
      'Prise en charge hôtel entre 4h00 et 5h00',
      'Mini-van climatisé (8 pers max)',
      'Collation',
      'Temple de Karnak',
      'Déjeuner buffet',
      'Temple d\'Hatshepsout',
      'Vallée des Rois',
      'Statues de Memnon',
      'Mini croisière sur le Nil incluse',
      'Retour hôtel vers 21h00'
    ],
    included: [
      'Billets',
      'Mini croisière Nil',
      'Repas + boisson',
      'Transfert hôtel aller-retour'
    ],
    notIncluded: [
      'Banana Island (+10€)',
      'Pourboires (optionnel)'
    ],
    practicalInfo: {
      duration: '1 jour',
      departurePoint: 'Hôtel',
      departureTime: '4h00 – 5h00',
      returnTime: 'Vers 21h00'
    },
    faq: [
      {
        question: 'Le transfert depuis mon hôtel est-il inclus ?',
        answer: 'Oui, la prise en charge depuis ton hôtel à Hurghada est incluse, sauf mention contraire.'
      },
      {
        question: 'Comment se passe le paiement ?',
        answer: 'Tu réserves ton pack avec un acompte sécurisé via Stripe. Le solde est à régler le jour de l\'excursion, directement auprès du prestataire local. Aucun frais caché, tout est clair dès le départ.'
      },
      {
        question: 'Comment se passe la confirmation ?',
        answer: 'Après le paiement, je te contacte directement sur WhatsApp pour confirmer tous les détails.'
      },
      {
        question: 'Puis-je poser des questions sur cette activité ?',
        answer: 'Oui, je suis disponible à tout moment sur WhatsApp avant et après la réservation.'
      }
    ]
  },
  'balade-cheval-hurghada': {
    id: 'balade-cheval-hurghada',
    slug: 'balade-cheval-hurghada',
    title: 'Balade à cheval à Hurghada',
    metaTitle: 'Balade à Cheval Hurghada – Mer, Désert & Coucher de Soleil | Réservez en Français',
    metaDescription: 'Balade à cheval à Hurghada entre mer et désert au coucher du soleil. Dîner inclus. Réservation simple en français via WhatsApp.',
    h1: 'Balade à cheval à Hurghada',
    price: 30,
    priceNote: 'Transport inclus • Dîner inclus',
    duration: 'Soirée',
    departurePoint: 'Hôtel',
    departure: 'Selon la saison',
    return: 'En soirée',
    stripeLink: 'https://buy.stripe.com/6oU5kC92B9CM0lV0J7dMI06',
    depositAmount: 10,
    shortDescription: 'Une expérience inoubliable vous attend à cheval, entre mer, désert et coucher de soleil.',
    images: [
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767544712/horse-riding-hurghada_2_irdzet.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767544712/horse-riding-hurghada_3_hls8sq.jpg',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767544721/horse-riding-hurghada_1_whlt0w.png'
    ],
    experience: [
      'Prise en charge à votre hôtel dans Hurghada',
      'Transfert vers le lieu de l\'activité',
      'Balade à cheval en direction de la mer',
      'Promenade le long de la mer avec arrêt photos',
      'Possibilité de galop (selon niveau)',
      'Retour à travers le désert au coucher du soleil',
      'Buffet à volonté accompagné d\'un spectacle oriental',
      'Retour à votre hôtel avec chauffeur'
    ],
    included: [
      'Buffet à volonté et une boisson offerte',
      'Transfert hôtel aller-retour (si hôtel situé à Hurghada)'
    ],
    notIncluded: [
      'Boissons supplémentaires',
      'Photos professionnelles',
      'Pourboires (optionnel)'
    ],
    practicalInfo: {
      duration: 'Soirée',
      departurePoint: 'Hôtel',
      departureTime: 'Selon la saison (confirmé par WhatsApp)',
      returnTime: 'En soirée'
    },
    faq: [
      {
        question: 'Le transfert depuis mon hôtel est-il inclus ?',
        answer: 'Oui, la prise en charge depuis ton hôtel à Hurghada est incluse, sauf mention contraire.'
      },
      {
        question: 'Comment se passe le paiement ?',
        answer: 'Tu réserves ton pack avec un acompte sécurisé via Stripe. Le solde est à régler le jour de l\'excursion, directement auprès du prestataire local. Aucun frais caché, tout est clair dès le départ.'
      },
      {
        question: 'Comment se passe la confirmation ?',
        answer: 'Après le paiement, je te contacte directement sur WhatsApp pour confirmer tous les détails.'
      },
      {
        question: 'Puis-je poser des questions sur cette activité ?',
        answer: 'Oui, je suis disponible à tout moment sur WhatsApp avant et après la réservation.'
      }
    ]
  },
  'paradise-island': {
    id: 'paradise-island',
    slug: 'paradise-island',
    title: 'Paradise Island à Hurghada',
    metaTitle: 'Paradise Island Hurghada – Journée Bateau Mer Rouge | Réservez en Français',
    metaDescription: 'Excursion Paradise Island à Hurghada : snorkeling, déjeuner buffet et détente sur une île paradisiaque. Réservation simple en français via WhatsApp.',
    h1: 'Paradise Island à Hurghada – Journée bateau',
    price: 35,
    priceNote: 'Déjeuner & boissons inclus • Snorkeling inclus • Transport inclus',
    duration: 'Journée complète',
    stripeLink: 'https://buy.stripe.com/fZudR80w5cOY4CbfE1dMI05',
    depositAmount: 6,
    images: [
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767608441/paradise-island-turquoise-water.png_5_rwt43u.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767608437/paradise-island-turquoise-water.png_4_pene2a.png',
      'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto/v1767608432/paradise-island-turquoise-water.png_3_lbc2ab.png'
    ],
    departurePoint: 'Hôtel',
    departure: 'Entre 7h30 et 8h30',
    return: 'Environ 17h',
    shortDescription: 'Explorez les eaux cristallines et le climat tropical de Paradise Island lors d\'une excursion complète en mer Rouge.',
    mainImage: 'https://res.cloudinary.com/dzx5jx8fr/image/upload/f_auto,q_auto,w_1200/v1767608432/paradise-island-turquoise-water.png_3_lbc2ab.png',
    heroFeatures: [
      'Déjeuner & boissons inclus',
      'Snorkeling inclus',
      'Transport inclus'
    ],
    experienceIntro: 'Départ depuis votre hôtel entre 7h30 et 8h30 pour embarquer vers 9h.',
    experience: [
      'Prise en charge à votre hôtel entre 7h30 et 8h30',
      'Embarquement vers 9h00',
      'Direction l\'un des meilleurs spots de plongée pour une séance de snorkeling avec le matériel fourni',
      'Buffet à volonté avec boissons servi à bord pendant la navigation vers Paradise Island',
      'Transfert en bateau à moteur jusqu\'à l\'île',
      '1h30 de quartier libre sur l\'île (extras disponibles : glaces, cocktails, chicha)',
      'Retour en bateau vers le bateau principal avec possibilité de participer à des jeux aquatiques (banane, sofa)',
      'Retour à l\'hôtel prévu vers 17h'
    ],
    included: [
      'Excursion bateau à la journée',
      'Séance de snorkeling avec matériel fourni',
      'Déjeuner buffet à volonté',
      'Boissons incluses',
      'Jeux aquatiques (banane, sofa)',
      'Transfert hôtel aller-retour (si hôtel situé à Hurghada)'
    ],
    notIncluded: [
      'Extras sur l\'île (glaces, cocktails, chicha)'
    ],
    practicalInfo: {
      duration: 'Journée complète',
      departurePoint: 'Hôtel',
      departureTime: 'Entre 7h30 et 8h30 (embarquement à 9h)',
      returnTime: 'Environ 17h'
    },
    faq: [
      {
        question: 'Le transfert depuis mon hôtel est-il inclus ?',
        answer: 'Oui, la prise en charge depuis ton hôtel à Hurghada est incluse, sauf mention contraire.'
      },
      {
        question: 'Comment se passe le paiement ?',
        answer: 'Tu réserves ton pack avec un acompte sécurisé via Stripe. Le solde est à régler le jour de l\'excursion, directement auprès du prestataire local. Aucun frais caché, tout est clair dès le départ.'
      },
      {
        question: 'Comment se passe la confirmation ?',
        answer: 'Après le paiement, je te contacte directement sur WhatsApp pour confirmer tous les détails.'
      },
      {
        question: 'Puis-je poser des questions sur cette activité ?',
        answer: 'Oui, je suis disponible à tout moment sur WhatsApp avant et après la réservation.'
      },
      {
        question: 'Faut-il avoir déjà plongé ?',
        answer: 'Non. Les débutants sont acceptés et accompagnés par des professionnels.'
      },
      {
        question: 'Le matériel est-il inclus ?',
        answer: 'Oui, tout le matériel nécessaire est fourni.'
      },
      {
        question: 'Est-ce adapté aux débutants ?',
        answer: 'Oui, les activités sont encadrées et adaptées aux personnes sans expérience.'
      }
    ]
  }
};

// Note: whatsappLink is deprecated, use getWhatsAppLink() from utils/whatsapp.js instead
export const whatsappLink = 'https://wa.me/201221948907?text=Bonjour%2C%20je%20souhaite%20des%20informations%20sur%20les%20excursions%20%C3%A0%20Hurghada';
